import { Link } from 'react-router-dom';
import { PageHeader } from '@/components/layout/PageHeader';
import { QuickActionGrid } from '@/components/ui/QuickActionGrid';
import { PageSection } from '@/components/ui/PageSection';
import { StatCard } from '@/components/ui/StatCard';
import { KpiGrid } from '@/components/ui/KpiGrid';

export type WorkspaceAction = {
  to: string;
  label: string;
  description: string;
};

export type WorkspaceKpi = {
  title: string;
  value: string | number;
};

type FinanceWorkspaceHubProps = {
  title: string;
  description: string;
  breadcrumbs: Array<{ label: string; to?: string }>;
  kpis?: WorkspaceKpi[];
  actions: WorkspaceAction[];
  guidance?: string;
  headerActions?: React.ReactNode;
  children?: React.ReactNode;
};

export function FinanceWorkspaceHub({
  title,
  description,
  breadcrumbs,
  kpis,
  actions,
  guidance,
  headerActions,
  children,
}: FinanceWorkspaceHubProps) {
  return (
    <div>
      <PageHeader
        title={title}
        description={description}
        breadcrumbs={[{ label: 'Org', to: '/org' }, { label: 'Finance', to: '/finance' }, ...breadcrumbs]}
        actions={headerActions}
      />

      {guidance && (
        <div className="mb-4 rounded-lg border border-primary-100 bg-primary-50/80 px-4 py-3 text-sm text-primary-900 dark:border-primary-900 dark:bg-primary-950/40 dark:text-primary-100">
          {guidance}
        </div>
      )}

      {kpis && kpis.length > 0 && (
        <KpiGrid className="mb-6">
          {kpis.map((kpi) => (
            <StatCard key={kpi.title} title={kpi.title} value={kpi.value} />
          ))}
        </KpiGrid>
      )}

      <PageSection title="What do you want to do?">
        <QuickActionGrid items={actions} columns={2} />
      </PageSection>

      {children}

      <p className="mt-6 text-xs text-slate-500">
        Need accounting detail?{' '}
        <Link to="/finance/accounting" className="text-primary-600 hover:underline">
          Open accounting workspace
        </Link>{' '}
        (for accountants only).
      </p>
    </div>
  );
}
